import {StoreData} from "../../StoreDetail/StoreDetailServices";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import './sections.scss'
import {MenuList} from "./MenuList";
import {MenuRootList} from "./MenuRootList";

const MyRecentMerchantMenu = ({item}) =>{

    const history = useHistory();

    const mapsSelector = () => {
        let coordinates = item.geometry? item.geometry.coordinates:null;
        if (coordinates) {
            if /* if we're on iOS, open in Apple Maps */
            ((navigator.platform.indexOf("iPhone") !== -1) ||
                (navigator.platform.indexOf("iPad") !== -1) ||
                (navigator.platform.indexOf("iPod") !== -1))
                window.open("maps://maps.google.com/maps?daddr=" + coordinates[0] + "," + coordinates[1] + "&amp;ll=");
            else /* else use Google */
                window.open("https://maps.google.com/maps?daddr=" + coordinates[0] + "," + coordinates[1] + "&amp;ll=");
        }
    }


    const getMerchant = async () =>{
        try {
            let response = await StoreData(item.items[0].link_to_uid);
            setLast(response.data)
        } catch (e) {
            // console.log(e)
        }
    }
    const [last,setLast] = useState()
    useEffect(()=>{
        getMerchant()
    },[])

    return(
        <div>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="MyRecentMerchant-container">
                {last?
                    <div>
                        <div className="last-title">
                            <span className="last-title-hint">(آخرین مراجعه شما)</span>
                            <span className="last-title-name">{last.name}</span>
                        </div>

                        {/*<MenuList item={item}/>*/}
                        <MenuRootList item={item}/>
                    </div>
                    :null}
            </div>
        </div>
    )
}

export {MyRecentMerchantMenu}
